import * as React from "react";
import { Button, DialogActions, DialogContent } from "@material-ui/core";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";

// components
import { SidebarDialog } from "@components/sidebar-dialog";

// styles
import * as s from "./CookieDialog.styles";

export interface IProps extends WithStyles<typeof s.styles> {
  isChromeExtension?: boolean;
  open?: boolean;
}

class CookieDialogComponent extends React.Component<IProps, {}> {
  public render() {
    return (
      <SidebarDialog open={!!this.props.open} isChromeExtension={this.props.isChromeExtension}>
        <DialogContent>
          <div style={s.dialog.header}>Please enable cookies to sign in to Clockwise</div>
          <div style={s.dialog.description}>
            Google sign in requires that third party cookies are enabled to work properly.
          </div>
          <div style={s.dialog.listItem}>
            <span style={s.dialog.bullet}>1.</span>
            <span style={s.dialog.label}>
              Open cookie settings by going to this url: chrome://settings/cookies
            </span>
          </div>
          <div style={s.dialog.listItem}>
            <span style={s.dialog.bullet}>2.</span>
            <span style={s.dialog.label}>
              At the bottom, go to the the "Customized behaviors" section
            </span>
          </div>
          <div style={s.dialog.listItem}>
            <span style={s.dialog.bullet}>3.</span>
            <span style={s.dialog.label}>
              Next to the "Sites that can always use cookies" section, click "Add"
            </span>
          </div>
          <div style={s.dialog.listItem}>
            <span style={s.dialog.bullet}>4.</span>
            <span style={s.dialog.label}>
              In the dialog that opens, copy and paste: [*.]getclockwise.com
            </span>
          </div>
          <div style={s.dialog.listItem}>
            <span style={s.dialog.bullet}>5.</span>
            <span style={s.dialog.label}>
              Repeat step 3, this time in the dialog copy and paste: [*.]google.com
            </span>
          </div>
          <div style={s.dialog.learnMore}>
            Without this setting, Clockwise may be unable to log you in or keep your session active.
          </div>
        </DialogContent>
        <DialogActions style={{ padding: "0 24px 24px" }}>
          <Button
            classes={{ label: this.props.classes.buttonLabelStyle }}
            color="primary"
            variant="contained"
            onClick={() => window.location.reload()}
          >
            Try again
          </Button>
        </DialogActions>
      </SidebarDialog>
    );
  }
}

/////////////////
// With Styles //
/////////////////

export const CookieDialog = withStyles(s.styles)(CookieDialogComponent);
